import CheckIcon from '~/assets/svgs/icon-check.svg?react'
import FilterIcon from '~/assets/svgs/icon-filter.svg?react'
import { QuickActionButtonVariants } from '~/components/shared/componentStyles/QuickActionButton.style'
import { DropdownActionButton } from '~/components/shared/Dropdown/DropdownActionButton'
import { MenuListItem } from '~/components/shared/Dropdown/MenuItem'
import { colorPalette } from '~/themes/colors/colorPalette'
import { FaxDirectionFilter } from '~/types/ApiRequestTypes'
import { Size } from '~/types/ThemeTypes'

import { filterDefaults, useFaxViewModel } from './Fax.viewmodel'

/** A menu button for filtering faxes by direction */
function Button() {
  const {
    actions: { setDirectionFilter },
    state: { directionFilter, directionFilterMenu },
  } = useFaxViewModel()

  function changeDirectionFilter(value: FaxDirectionFilter) {
    /** Set to `All` when deselecting the current selection */
    const next = directionFilter === value ? FaxDirectionFilter.ALL : value
    setDirectionFilter(next)
    directionFilterMenu.lid.close()
  }

  return (
    <DropdownActionButton
      icon={FilterIcon}
      items={directionFilterMenu.options.map((option) => ({
        content: (
          <MenuListItem
            primaryText={option.label}
            rightContent={
              directionFilter === option.value ? (
                <CheckIcon style={{ color: colorPalette.black }} />
              ) : null
            }
          />
        ),
        value: option.value,
      }))}
      menuOptions={{
        width: '300px',
      }}
      onSelect={changeDirectionFilter}
      selectedIndex={directionFilterMenu.options.findIndex(
        (option) => option.value === directionFilter,
      )}
      size={Size.md}
      tooltipText="Direction Filter"
      variant={
        directionFilter === filterDefaults.direction
          ? QuickActionButtonVariants.Default_100
          : QuickActionButtonVariants.Default_300
      }
    />
  )
}

export const FaxDirectionFilterMenu = {
  Button,
}
